import { createApp } from 'vue'
import './style.css'
import '@/assets/pill.css'
import App from './App.vue'
import router from './router/routes.js'
import { createPinia } from 'pinia'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'
import AnimatedCounter from "vue-animated-counter"
import { pinia as authStore } from './stores/auth.js'

const pinia = createPinia()

const app = createApp(App)
  .use(router)
  .use(pinia)
  .use(authStore)
  .use(Vueform, vueformConfig);

AOS.init({ once: false });

app.component("AnimatedCounter", AnimatedCounter);

app.mount('#app');
